import React from "react";
import {
  Box,
  Typography,
  Container,
  Grid,
  Link,
  Divider,
} from "@mui/material";

function Footer() {
  return (
    <Box
      component="footer"
      sx={{
        py: 5,
        backgroundColor: "primary.dark",
        color: "#fff",
        mt: 8,
        borderTop: "4px solid",
        borderColor: "secondary.main",
      }}
    >
      <Container maxWidth="lg">
        <Grid container spacing={4}>
          {/* Company Information */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              PM Enterprise
            </Typography>
            <Typography variant="body2" sx={{ mb: 1, color: "rgba(255,255,255,0.7)" }}>
              Trusted since 2003 in residential and commercial services:
              interior/exterior painting, wood polishing, texture finishes, and waterproofing.
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)" }}>
              We specialise in premium finishes and custom colour matching.
            </Typography>
          </Grid>

          {/* Contact Details */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Contact
            </Typography>
            <address style={{ fontStyle: "normal" }}>
              <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)" }}>25 B/4, Gayatri Nagar, Chandlodiya</Typography>
              <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)" }} >Ahmedabad, Gujarat 382481</Typography>
            </address>
            <Typography variant="body2" sx={{ mt: 1, color: "rgba(255,255,255,0.7)" }}>
              Phone:&nbsp;
              <Link href="tel:+919173286204" sx={{ color: "rgba(255,255,255,0.7)" }} underline="hover" aria-label="Call 91732 86204">
                +91 91732 86204
              </Link>
              &nbsp;/&nbsp;
              <Link href="tel:+919429632019" sx={{ color: "rgba(255,255,255,0.7)" }} underline="hover" aria-label="Call 94296 32019">
                94296 32019
              </Link>
            </Typography>
            <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)" }}>
              Email:&nbsp;
              <Link
                href="mailto:pmenterprises.painters@gmail.com"
                color="inherit"
                underline="hover"
                aria-label="Email PM Enterprises"
              >
                pmenterprises.painters@gmail.com
              </Link>
            </Typography>
          </Grid>

          {/* Quick Links */}
          <Grid item xs={12} sm={4}>
            <Typography variant="h6" sx={{ mb: 1 }}>
              Quick Links
            </Typography>
            {[
              { label: "Home", href: "/" },
              { label: "Why Us", href: "/why-us" },
              { label: "Services", href: "/services" },
              { label: "Paint Budget Calculator", href: "/paintcalculator" },
              { label: "Contact", href: "/contact" },
              { label: "Admin Login", href: "/admin-login" },
            ].map((link) => (
              <Link
                key={link.href}
                href={link.href}
                underline="hover"
                color="inherit"
                sx={{
                  display: "block",
                  mb: 0.5,
                  transition: "color 0.3s",
                  "&:hover": {
                    color: "secondary.main",
                  },
                }}
              >
                {link.label}
              </Link>
            ))}
          </Grid>
        </Grid>

        <Divider sx={{ my: 4, borderColor: "rgba(255,255,255,0.2)" }} />

        {/* Footer Bottom */}
        <Box textAlign="center">
          <Typography variant="body2" sx={{ color: "rgba(255,255,255,0.7)" }}>
            © {new Date().getFullYear()} PM Enterprise. All rights reserved.
          </Typography>
        </Box>
      </Container>
    </Box>
  );
}

export default Footer;
